import { FC, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './fresh-user-credits.scss';
import CreditsImg from './components/credits.png';
import FontAwesomeIcon from '../font-awesome-icon/font-awesome-icon';
import Routes from '../../constants/routes';
import qualityEvents from '../../services/quality-events';
import detectDevice from '../../utils/detect-device';
import detectBrowser from '../../utils/detect-browser';
import Button from '../button/button';
import { ALLOCATION_REASONS, NOTIFICATIONS } from '../../constants/credits';
import translation from '../../languages';
import Spacing from '../spacing/spacing';
import { BUTTON_VARIANTS } from '../../constants/button-variants';
import isUITest from '../../utils/is-ui-test';

const FreshUserCredits: FC<TranslationProps> = ({ t }) => {
    const [showModal, setShowModal] = useState(false);
    const websocket = useSelector((state: RootState) => state.main.websocket);

    const onClose = () => {
        window.location.reload();
    };

    const sendQualityEvent = () => {
        qualityEvents.track({
            extra: JSON.stringify({
                user_id: window.storage.getItem('userId')
            }),
            page_url: window.location.href,
            type: 'allocatedCreditsCampaign:popupShown',
            user_agent: detectBrowser(),
            user_device: detectDevice()
        });
    };

    const onMessage = (data: IWebsocketMessage) => {
        if (
            data.type === NOTIFICATIONS.CREDITS_ALLOCATED &&
            data.message.reason === ALLOCATION_REASONS.FIRST_DOWNLOAD
        ) {
            setShowModal(true);
            sendQualityEvent();
        }
    };

    const handleClick = () => {
        window.locationReload(Routes.SEARCH_RESULT.path);
    };

    useEffect(() => {
        if (websocket.lastMessage && websocket.connected) {
            onMessage(websocket.lastMessage);
        }
    }, [websocket.lastMessage, websocket.connected]);

    if (!showModal || isUITest()) {
        return null;
    }

    return (
        <Modal show dialogClassName='fresh-user-credits-modal position-relative'>
            <span
                className='position-absolute close-button cursor-pointer d-flex justify-content-center align-items-center'
                onClick={onClose}
            >
                <FontAwesomeIcon height={20} name='times' />
            </span>
            <div className='content text-center'>
                <div className='tsc-h2 mb-4'>{t('modals.allocatedCreditsModal.title')}</div>
                <div className='mb-3 tsc-subheadline subtitle'>{t('modals.allocatedCreditsModal.subtitle')}</div>
                <div>
                    <img alt='' src={CreditsImg} />
                </div>
                <div>
                    <div className='tsc-h2 colored'>
                        {t('modals.allocatedCreditsModal.onlyToday')}
                        <Spacing />:
                    </div>{' '}
                    <div className='tsc-h1'>**{t('modals.allocatedCreditsModal.price', { value: 3 })}**</div>
                </div>
                <div className='tsc-h4'>{t('modals.allocatedCreditsModal.purpose')}</div>
                <div className='mt-5 d-flex justify-content-center align-items-center'>
                    <div className='button-wrapper'>
                        <Button variant={BUTTON_VARIANTS.YELLOW} onClick={handleClick}>
                            {t('modals.allocatedCreditsModal.allocateNow')}
                        </Button>
                        <div className='colored text-right mt-1'>
                            <b>{t('modals.allocatedCreditsModal.tip', { value: 5 })}</b>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const tranlate = translation('modals');

export default tranlate(FreshUserCredits);
